/**
 * <ModalContent />
 *
 * @parent Modal 
 * @stateless
 */
import React, { PropTypes } from 'react';
import SocialMediaButton from 'shared/SocialMediaButton';
import QRCode from 'components/UI/QrCode';

class ModalContent extends React.Component {
  render() {
    const {
      pageTitle,
      pageUrl,
    } = this.props;
    
    return (
      <div className='share-on-social-media-content'>
        <SocialMediaButton buttons={['facebook', 'twitter', 'wechat']} pageUrl={pageUrl} pageTitle={pageTitle} /> 
        <input type='text' value={pageUrl} className='form-control' />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/ShareOnSocialMedia/ModalContent.js